<div class="animated fadeIn fast">
  <form [formGroup]="form" [class.mt-10]="anyAlert() || loading" appBlockCopyPaste>
    <app-alert *ngIf="!match" [alert]="constants.alerts.nonMatchingPasswords"></app-alert>
    <app-alert *ngIf="error" [alert]="error"></app-alert>
    <app-loading *ngIf="loading"></app-loading>
    <div *ngIf="!loading">
      <div class="row mb-30 mt-10 text-center">
        <p class="col-md-12 text-left">
          Crea tu nueva clave, esta debe contener
          <b class="primary">6 dígitos.</b>
        </p>
      </div>
      <div class="row text-center">
        <div class="col-md-6">
          <div class="form-group" [class.has-error]="helpers.invalidControl(form.get('password'))">
            <label
              for="password"
              class="label-form label-create-form label-password"
              >Nueva clave</label
            >
            <input
              type="password"
              formControlName="password"
              class="form-control"
              maxlength="6"
              mask="0*"
              (keyup)="keyUp($event)"
            />
            <span
              class="help-block invalid-feedback"
              *ngIf="helpers.invalidControl(form.get('password'))"
            >
              <span class="d-flex" *ngIf="form.get('password').errors.required">{{
                constants.validations.required.message
              }}</span>
              <span class="d-flex" *ngIf="form.get('password').errors.consecutiveDigits || form.get('password').errors.repeatingDigits">{{
                constants.validations.invalidFormat.message
              }}
              </span>
              <span
                class="d-flex"
                *ngIf="
                  form.get('password').errors.minlength &&
                  !form.get('password').errors.pattern
                "
                >{{ constants.validations.minDigits.message }}</span
              >
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group" [class.has-error]="helpers.invalidControl(form.get('confirmPassword'))">
            <label
              for="confirmPassword"
              class="label-form label-create-form label-password"
              >Confirma tu nueva clave</label
            >
            <input
              type="password"
              formControlName="confirmPassword"
              class="form-control"
              maxlength="6"
              mask="000000"
              (keyup)="keyUp($event)"
            />
            <span
              class="help-block invalid-feedback"
              *ngIf="helpers.invalidControl(form.get('confirmPassword'))"
            >
              <span class="d-flex" *ngIf="form.get('confirmPassword').errors.required">{{
                constants.validations.required.message
              }}</span>
              <span class="d-flex" *ngIf="form.get('confirmPassword').errors.consecutiveDigits || form.get('confirmPassword').errors.repeatingDigits">{{
                constants.validations.invalidFormat.message
              }}
              </span>
              <span
                class="d-flex"
                *ngIf="
                  form.get('confirmPassword').errors.minlength &&
                  !form.get('confirmPassword').errors.pattern
                "
                >{{ constants.validations.minDigits.message }}</span
              >
            </span>
          </div>
        </div>
      </div>
      <div class="mt-15">
        <p class="text-left">
          *Recuerda no ingresar números consecutivos (Ej: 123456, 654321).
        </p>
        <p class="text-left">
          *Recuerda no ingresar números que se repitan 4 o más veces de manera consecutiva
          <br>
          (Ej: 111106, 092222).
        </p>
        <p class="text-left">
          *Recuerda no ingresar números que sean parte del número de teléfono registrado
          <br>
          (Ej: N° de teléfono: 225118342 y Contraseña: 118342).
        </p>
        <p class="text-left">
          *Recuerda no ingresar números que sean parte o la totalidad de tu número de documento ya sea del tipo DNI o CE
          <br>
          (Ej: N° de documento: 15591292 y Contraseña: 155912).
        </p>
      </div>
      <div *ngIf="!loading" class="row text-center">
        <button
          [disabled]="form.invalid || !match"
          (click)="continue()"
          class="button-continue button-find-label"
        >
          Continuar
        </button>
      </div>
    </div>
  </form>
</div>
